export const GROUP_BY_OPTIONS = [
  { id: null, label: 'Time' },
  { id: 'associated_job_name', label: 'Associated job', key: 'g1.name' },
  { id: 'requisition_type', label: 'Requisition type', key: 'g1.name' },
  { id: 'recruiter', label: 'Recruiter', key: 'g1.name' },
  { id: 'hiring_manager', label: 'Hiring manager', key: 'g1.name' },
  { id: 'department', label: 'Department', key: 'g1.name' },
  { id: 'office', label: 'Office', key: 'g1.name' },
  { id: 'work_type', label: 'Work type', key: 'g1.name' },
  {
    id: 'requester',
    label: 'User',
    key: 'user',
  },
];

export const BREAKDOWN_OPTIONS = [
  { id: null, label: 'None' },
  { id: 'associated_job_name', label: 'Associated job', key: 'g1.name' },
  { id: 'requisition_type', label: 'Requisition type', key: 'g1.name' },
  { id: 'recruiter', label: 'Recruiter', key: 'g1.name' },
  { id: 'hiring_manager', label: 'Hiring manager', key: 'g1.name' },
  { id: 'department', label: 'Department', key: 'g1.name' },
  { id: 'office', label: 'Office', key: 'g1.name' },
  { id: 'work_type', label: 'Work type', key: 'g1.name' },
];
